const body = {
	current: '',
	list: [	]
}

export {
	body
}
